// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //APIEndpoint: 'http://localhost:5000/v1/',  
  //APIEndpoint: 'http://192.168.1.3:5000/v1/',
  //APIEndpoint: 'http://cpro50744.publiccloud.com.br:5000/v1/', 
  APIEndpoint: 'https://api-h.fragmaq.app.br/v1/',
  NotaFiscalEndpoint: 'https://api-h.fragmaq.app.br/',
  AnexoEndpoint: 'https://api-h.fragmaq.app.br/',
  //APIEndpoint: 'https://api.fragmaq.app.br/v1/',
  versao: 5,
  ambiente: "HOM"
  //NotaFiscalEndpoint: 'https://api.fragmaq.app.br/',
  //AnexoEndpoint: 'https://api.fragmaq.app.br/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
